module.exports = __webpack_public_path__ + "static/media/support.3e22ed8a.png";